module.exports = __webpack_public_path__ + "4f5f6adffe8cf501940472faa9576792.png";